import { render } from "./AssetNotificationHistoryView.vue?vue&type=template&id=75b1cc12&scoped=true&ts=true"
import script from "./AssetNotificationHistoryView.vue?vue&type=script&lang=ts"
export * from "./AssetNotificationHistoryView.vue?vue&type=script&lang=ts"

import "./AssetNotificationHistoryView.vue?vue&type=style&index=0&id=75b1cc12&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b1cc12"]])

export default __exports__